import { z } from "zod";
import { PERMISSION_ROLES, type PermissionRole } from "@/shared/lib/roles";

// Mirrors the server-side UserManagementRules.MaxDisplayNameLength.
export const MAX_DISPLAY_NAME_LENGTH = 32;

// Mirrors the server-side UserUpdate. displayName trimmed, empty → null (username fallback).
export const rosterRowSchema = z.object({
  userId: z.string(),
  displayName: z
    .string()
    .trim()
    .max(
      MAX_DISPLAY_NAME_LENGTH,
      `Visningsnamnet får vara högst ${MAX_DISPLAY_NAME_LENGTH} tecken`,
    )
    .transform((v) => (v === "" ? null : v)),
  permissionRole: z.enum(PERMISSION_ROLES),
});
export type RosterRowInput = z.input<typeof rosterRowSchema>;
export type RosterRowValues = z.output<typeof rosterRowSchema>;

// Local draft for one row; displayName is a raw string ("" = no name), sanitised via rosterRowSchema.
export type RowDraft = {
  displayName: string;
  permissionRole: PermissionRole;
};

// Mirrors the server-side InviteRules.DurationFor allow-list; the backend enforces the ceiling.
export const INVITE_DURATIONS = ["1d", "7d", "30d"] as const;
export const inviteFormSchema = z.object({
  duration: z.enum(INVITE_DURATIONS),
});
export type InviteFormInput = z.input<typeof inviteFormSchema>;
export type InviteFormValues = z.output<typeof inviteFormSchema>;
